import { CompaniesIcon, ContactsIcon, MeetingsIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useRef } from 'react';
import { useReactNodeView } from '../utils/ReactNodeView';
import { CALYPSO, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const personalizationTokenIconMap = {
  companies: CompaniesIcon,
  contacts: ContactsIcon,
  meetings: MeetingsIcon
};
const DEFAULT_BACKGROUND_COLOR = CALYPSO_LIGHT;
const DEFAULT_BORDER_COLOR = CALYPSO_LIGHT;
const DEFAULT_FONT_COLOR = CALYPSO;
const DEFAULT_PADDING = '4px 8px';
const StyledToken = styled.span.withConfig({
  displayName: "PersonalizationTokenView__StyledToken",
  componentId: "szf8bb-0"
})(["align-items:center;background-color:", ";border:1px solid ", ";border-radius:2px;color:", ";cursor:default;display:inline-flex;line-height:1;margin:0;padding:", ";vertical-align:middle;user-select:text;white-space:nowrap;width:auto;"], props => props.backgroundColor || DEFAULT_BACKGROUND_COLOR, props => props.borderColor || DEFAULT_BORDER_COLOR, props => props.fontColor || DEFAULT_FONT_COLOR, props => props.padding || DEFAULT_PADDING);
export function PersonalizationTokenView() {
  const {
    node
  } = useReactNodeView();
  const attrs = useRef(node ? node.attrs : {});
  const tokenIconKey = attrs.current.tokenStyles.tokenIconKey;
  return /*#__PURE__*/_jsxs(StyledToken, {
    backgroundColor: attrs.current.tokenStyles.backgroundColor,
    borderColor: attrs.current.tokenStyles.borderColor,
    fontColor: attrs.current.tokenStyles.fontColor,
    padding: attrs.current.tokenStyles.padding,
    className: "ProseMirror__personalizationToken",
    children: [personalizationTokenIconMap[tokenIconKey] && /*#__PURE__*/_jsx(IconHolder, {
      icon: personalizationTokenIconMap[tokenIconKey],
      marginInlineEnd: "200",
      padding: "0"
    }), attrs.current.displayText || attrs.current.tokenKey]
  });
}
PersonalizationTokenView.displayName = 'PersonalizationTokenView';
export function personalizationTokenViewUpdateFn({
  previousNode,
  node
}) {
  if (previousNode.attrs.tokenKey !== node.attrs.tokenKey) {
    return false;
  }
  return true;
}